module.exports = __webpack_public_path__ + "img/white.f9fd56df.png";